import {executeCrudEpic, Type} from 'lib/crud'
import {name} from 'lib/specialists'
import {dao} from 'lib/users'
import {combineEpics} from 'redux-observable'

export const specialistsEpics = combineEpics(
    executeCrudEpic(name, Type.LIST)(dao.list),
    executeCrudEpic(name, Type.GET)(dao.get),
)